import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FileInfoType, FileListService } from '@schoolbelle/api/file';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-letter-write-file-list',
  templateUrl: './letter-write-file-list.component.html',
  styleUrls: ['./letter-write-file-list.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LetterWriteFileListComponent implements OnInit {
  @Input() filelist:FileListService
  @Input() showMimeType:boolean = false;
  subscription = new Subscription();
  constructor(
    private cdRef:ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.filelist.onChange.subscribe(()=>{
        this.cdRef.detectChanges()
      })
    );
  }
  remove (file:File|FileInfoType) {
    this.filelist.remove(file);
  }
}
